<mat-card-content>
  <mat-dialog-content>
    <div>
      <p>Cette session sera fermer dans <b>{{counter}}</b> pour temps d'inactivite</p>
    </div>
    <div fxLayout="row" fxLayoutGap="10px">
      <button
        mat-raised-button
        cdkFocusInitial (click)="continue()"
        color="primary" tabindex="2"
      >
        <span>{{
          "buttons.continue" | translate
        }}</span>
      </button>
      <a (click)="close()" color="danger" mat-raised-button>{{
        "logout" | translate
      }}</a>
    </div>
  </mat-dialog-content>
</mat-card-content>
